import React from "react";
import { Link } from "react-router-dom";

const MyApiPlan = ({ apiPlan, planLabel }) => {
  /*
        planLabel is the server's name for the plan (backend#103), and it is
        the only thing rendered for a customer whose plan has no card in
        planCardData — the Enterprise, Unlimited and Custom 10 Courses plans
        that exist in Stripe but not in the pricing page's data. Those
        customers used to get a blank panel reading "$ per month", because
        every field here came from a lookup that found nothing.
    */
  if (!apiPlan) {
    return (
      <div>
        <strong>{planLabel || "Your plan"}</strong>
        <p>
          Contact{" "}
          <a href="mailto:apisupport@golfbert.com" className="link-to">
            apisupport@golfbert.com
          </a>{" "}
          for the details of this plan.
        </p>
      </div>
    );
  }

  return (
    <div>
      <strong>{apiPlan?.nickname}</strong>
      <p>{apiPlan?.subTitle}</p>
      <strong>${apiPlan?.unit_amount} per month</strong>
      <strong>Calls per month</strong>
      <p className="mb-0">{apiPlan?.callPerMon.split(" ")[0]}</p>
      <p className="text-muted font-italic">{apiPlan?.additionalApi}</p>
      <strong>Course access</strong>
      <p>{apiPlan?.nickname.replace("Golf", "")}</p>
      <strong>Included Support</strong>
      <p className="mb-0">
        response time :
        <b>{apiPlan?.bussinessDay.replace("response time", "")}</b>
      </p>
      <p className="mb-0"> {apiPlan?.submit}</p>
      <p className="mb-3"> {apiPlan?.report}</p>{" "}
      {apiPlan?.nickname === "Single Golf Course" && (
        <Link to="/api/plans" className="link-to fw--500 ">
          Upgrade to All Courses
        </Link>
      )}
    </div>
  );
};

export default MyApiPlan;
